
export const SYSTEM_NOTIFICATION_TYPES = ['user_registration'];
